import { z } from 'zod';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/trnsact-scorecard-sdk';

export const criteriaConditionSchema = z.object({
  fact: z.union([z.nativeEnum(FACT_NAMES_BOOLEAN), z.nativeEnum(FACT_NAMES_NUMERIC), z.nativeEnum(FACT_NAMES_STRING)]),
  boolean: z.object({
    value: z.boolean(),
  }),
  number: z.object({
    min: z.any().nullable(),
    max: z.any().nullable(),
  }),
  string: z.object({
    value: z.any(),
  }),
  isRequiredToQuote: z.boolean().optional(),
  score: z.any().nullable().optional(),
});
